<div class="modal-header">
    <h4 class="modal-title">Shipping Address</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="shipAddress" *ngIf="shipAddress">
        <dxi-item itemType="group">
            <!-- <dxi-item itemType="template" [label]="{ text: 'Select' }" *ngIf="showAddressSelect">
                <div *dxTemplate>
                    <dx-select-box [(value)]="selectedAddress" [items]="addresses" displayExpr="display" (onValueChanged)="selectedAddressChange($event)"> </dx-select-box>
                </div>
            </dxi-item> -->
            <dxi-item dataField="companyName" [label]="{ text: 'Company' }" [disabled]="true" [editorOptions]="{ readOnly: true }"></dxi-item>
            <dxi-item dataField="location"></dxi-item>
            <dxi-item dataField="contactName"></dxi-item>
            <dxi-item dataField="email" [label]="{ text: 'Confirmation Email' }"></dxi-item>
            <dxi-item dataField="address1"></dxi-item>
            <dxi-item dataField="address2"></dxi-item>
            <dxi-item itemType="group" [colCount]="3" caption="">
                <dxi-item dataField="city" [colSpan]="2"></dxi-item>
                <dxi-item dataField="state" [visible]="shipAddress.country !== 'US'"></dxi-item>
                <dxi-item
                    dataField="state"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: states, showClearButton: false }"
                    [visible]="shipAddress.country === 'US'"
                ></dxi-item>
                <dxi-item dataField="zip"></dxi-item>
                <dxi-item dataField="country" editorType="dxSelectBox" [editorOptions]="{ items: countries, showClearButton: false }"></dxi-item>
                <dxi-item dataField="countryOther" [visible]="shipAddress.country == 'OTHER'"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2" caption="">
                <dxi-item dataField="phone1" [label]="{ text: 'Phone 1' }"></dxi-item>
                <dxi-item dataField="phone2" [label]="{ text: 'Phone 2' }"></dxi-item>
            </dxi-item>
            <dxi-item dataField="loadedMiles" editorType="dxNumberBox"></dxi-item>
            <dxi-item dataField="notes" [label]="{ text: 'Shipping Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button *ngIf="showCopyBilling" class="btn btn-info me-3" (click)="copyBilling()">Copy Billing</button>
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
